module.exports = __webpack_public_path__ + "img/logoadminbig.56385e77.png";